// Результат прикладной операции. Плановые неудачи (не найдено, нарушено правило,
// ошибка валидации) возвращаются здесь, а не исключением. В messages — коды
// ошибок (ErrorCode из @gr/core/errors), их переводит интерфейс.
export interface OperationResult<T> {
  success: boolean;
  data: T;
  messages: string[];
  /** Ошибки по полям формы: путь поля → код ошибки. */
  fieldErrors?: Record<string, string>;
}

export class ResultHelper {
  public static Ok<T>(data: T, messages: string[] = []): OperationResult<T> {
    return { success: true, data, messages };
  }

  public static Fail<T>(data: T, messages: string[], fieldErrors?: Record<string, string>): OperationResult<T> {
    return fieldErrors && Object.keys(fieldErrors).length > 0
      ? { success: false, data, messages, fieldErrors }
      : { success: false, data, messages };
  }

  /** Сужает неуспешный результат к другому типу данных, сохраняя коды и ошибки полей. */
  public static Forward<T>(failure: OperationResult<unknown>, data: T): OperationResult<T> {
    return ResultHelper.Fail(data, failure.messages, failure.fieldErrors);
  }
}
